var Plan = {
	mapNode:null,
	mapImage:null,
	center:{},
	processing:false,
	landmarks:[],
	conInfo:[],
	condata:{},
	connections:{},
	swipe:{},
	ar:0,
	scale:0.4,
	initialized: false,
	compassMode: false,
	width:0,
	height:0,
	lastDist:-1,
	repaint:null,
	here:{},
	origin:null,
	target:null,
	zooming:false,
	newScale:0,
	deltaScale:0,
	
	init: function() {
		if (!Plan.initialized) {
			//console.log("initialize");
			Plan.swipe = new swiper();
			/*
			AppEvent.on(player, "mouseDown", function(pe) { Plan.swipe.start(pe); console.log("mdown");});
			AppEvent.on(player, "mouseUp", function(pe) { Plan.swipe.end(pe); console.log("mup"); });
			AppEvent.on(player, "mouseMove", function(pe) { Plan.swipe.move(pe); console.log("mmove"); });
			*/
			$("#mapinfo").on(Events.pointer.down, function(pe) {Plan.swipe.start(Events.getPointerEvent(pe));Plan.checkDoubleTap();pe.stopPropagation(); pe.preventDefault();});
			$("#mapinfo").on(Events.pointer.up, function(pe) {Plan.swipe.end(Events.getPointerEvent(pe));pe.stopPropagation(); pe.preventDefault();});
			$("#mapinfo").on(Events.pointer.move, function(pe) {Plan.swipe.move(Events.getPointerEvent(pe));pe.stopPropagation(); pe.preventDefault();});

			$("#mapinfo").on(Events.pointer.up, ".plan-point", function(pe) {Plan.selectTarget(Events.getPointerEvent(pe)); Plan.swipe.end(Events.getPointerEvent(pe)); pe.preventDefault();});
			$("#mapinfo").on(Events.pointer.up, ".plan-point-exit", function(pe) {Plan.selectFloor(Events.getPointerEvent(pe)); Plan.swipe.end(Events.getPointerEvent(pe)); pe.preventDefault();});
			$("#mapinfo").on(Events.pointer.up, ".route_go", function(pe) {mapInfo.toggleMenu(); Plan.goOrigin();});
			$("#mapinfo").on(Events.pointer.up, ".target", function(pe) {Plan.actionTarget();});

			$("#mapinfo").on(Events.pointer.wheel, function(pe) {Plan.wheel(Events.getWheelEvent(pe));pe.stopPropagation(); pe.preventDefault();});
			
			AppEvent.on(player, "placeReady", function(pe) { Plan.placeReady(pe); Floors.init();});
			Plan.initialized = true;
		}
	},

	release: function() {
		$("#mapinfo").off(Events.pointer.down);
		$("#mapinfo").off(Events.pointer.up);
		$("#mapinfo").off(Events.pointer.move);		
	},

	load: function(plan_id) {
		ssi("Plan","load",{"plan":plan_id}, function(resp) {
			if (resp.data.plan_id != undefined) {
				Plan.start(resp.data);
			}
		});
	},

	setupFloors: function() {
		var l = Floors.findFloor(Plan.planData.plan_id);
		var levels = l.levels;

		$(".ffloors").html("");

		for(var n in levels) {
			if (levels[n].plan_id == Plan.planData.plan_id)
				$(".ffloors").append($('<a class="level active blink " onmousedown="Floors.load(' + levels[n].plan_id + ');" data-plan="2" href="javascript:void(null)">' + levels[n].level + '</a>'));
			else
				$(".ffloors").append($('<a class="level active" onmousedown="Floors.load(' + levels[n].plan_id + ');" data-plan="2" href="javascript:void(null)">' + levels[n].level + '</a>'));
		}
	},

	start: function(data) {
		//Plan.init();
				
		Plan.planData = data;
				
		$("#mapcontent").html(TPL.render("plan-main", {"planfile":data.planfile, "pdown": "on" + Events.pointer.down, "pup": "on" + Events.pointer.up}));
		var pt = $("<div class='plan-point'></div>");
		
		$(".plan_search_icon").on(Events.pointer.down, function(e) {
			Search.open();
		});

		Plan.setupFloors();

		$("#heading .title").html(data.title + " - Poziom " + data.plan_level);

		Plan.mapNode = new css3DNode("#plan-canvas");
		Plan.mapImage = new css3DNode("#plan-canvas img");

		//this.swipe = new swiper();
		
		if (!Plan.processing) {
			player.addProcess(Plan);
			Plan.processing = true;
		}

		player.preload(true);

		var img = new Image();
		img.onload = function() {
			player.preload(false);
			Plan.imageWidth = $("#plan-canvas img").width();
			Plan.imageHeight = $("#plan-canvas img").height();
		
			Plan._width = $("#mapcontent").width();
			Plan._height = $("#mapcontent").height();
			/*
			if (player._width > player._height) {
				Plan.scale = player._width / $("#plan-canvas img").width();
			} else {
				Plan.scale = player._height / $("#plan-canvas img").height();
			}
			*/

			var sw = Plan._width / $("#plan-canvas img").width();
			var sh = Plan._height / $("#plan-canvas img").height();
			Plan.scale = sw < sh ? sw : sh;

			$("#plan-canvas img").css("opacity", "1");
//			Plan.scale = 1.5;

			Plan.loadLandmarks(data);

			if (data.x != undefined && data.y != undefined) {
//				Plan.centerTo(Plan.imageWidth * 0.5, Plan.imageHeight * 0.5);
				Plan.centerTo(data.x, data.y);
			} else {
				//Plan.center.x += ((Plan.imageWidth * Plan.scale - Plan.imageWidth * pscale) * ((Plan.center.x) / (Plan.imageWidth * pscale)));
				//Plan.center.y += ((Plan.imageHeight * Plan.scale - Plan.imageHeight * pscale) * ((Plan.center.y) / (Plan.imageHeight * pscale)));

				Plan.centerTo(Plan.imageWidth * 0.5, Plan.imageHeight * 0.5);
			}

//			Dialog.hint("plan_open", "<img src='/html5/assets/wyznacz_trase.png' width='100%' style='max-width:300px;'>", "Wskaż wybrane punkty aby wyznaczyć trasę<br>", 17000, "dialog-tutorial");
			Dialog.hint("plan_open", "", TPL.lng("plan.start_tip", "<span class='high'>WSKAŻ</span>wybrane punkty aby wyznaczyć trasę") + "<br>", 17000, "dialog-tutorial");
		};

		img.src = "/storage/plan/" + data.planfile;
		
	},
	
	loadLandmarks: function(data) {
		Plan.planData = data;

		/*
		if (data.planspot_id != undefined) {
			Plan.here.x = data.x; Plan.here.y = data.y;
			Plan.here.place = data.place;
			Plan.here.planspot = data.planspot_id;
			Plan.origin = Plan.here;
		} else {
			Plan.here = {};
		}
		*/

//		Plan.centerTo(data.x, data.y);
		
		ssi("Plan","landmarks",{"plan":data.plan_id},function(resp) {
			var rdata = resp.data;
			
			Plan.landmarks = [];
			Plan.condata = {};

			for(var i = 0; i < rdata.length; i ++) {
				Plan.landmarks.push({"place":rdata[i]});

				if (Plan.here != undefined && Plan.here.place == rdata[i].place_id) {
					Plan.here.no = i;
				}

				if (Plan.origin != undefined && Plan.origin.place == rdata[i].place_id) {
					var placeName = rdata[i].place_name;
					if (placeName == "") placeName = "Panorama nr.";
					$("#route_from span").html("<b>Od: </b>" + placeName + " " + rdata[i].place_id);
				}
			}

			if (Plan.target != undefined && Plan.target.current != undefined) {
				/*
			if (Plan.target != undefined && Plan.target.current != undefined && Plan.landmarks[Plan.target.current] != undefined && Plan.landmarks[Plan.target.current].place.planspot_id == Plan.target.planspot) {
				var placeName = Plan.landmarks[Plan.target.current].place.place_name;
				if (placeName == "") placeName = "Panorama nr.";
				$("#route_to span").html("<b>Do: </b>" + placeName + " " + Plan.landmarks[Plan.target.current].place.place_id);
				*/
				$("#route_to span").html("<b>Do: </b>" + Plan.target.title);
			}
		
			if (Plan.target != undefined && Plan.origin != undefined) {
				$("#routebar").show();
				Plan.routeBarVisibility(1);
			}

			ssi("Plan","connections",{"plan":data.plan_id},function(resp) {
				var rdata = resp.data;
				
				for(var i = 0; i < rdata.length; i ++) {
					Plan.condata[rdata[i].spotA + "_" + rdata[i].spotB] = rdata[i];
					//Plan.conInfo.push(data[i]);
				}

				Plan.refresh();
			});
		});
	},

	refreshTarget: function(onroute) {
		
		if (Plan.origin != null || (Plan.origin != null && Plan.origin.no == -1)) {
			Plan.refreshOrigin();
		}		

		if (Plan.target != null) {
			var lm;
			if (Plan.target.current == -1) Plan.target.current = Plan.findNoByPlanspot(Plan.target.planspot);
			lm = Plan.landmarks[Plan.target.current];

			if (lm != undefined && Plan.landmarks[Plan.target.current] != undefined && Plan.landmarks[Plan.target.current].place.planspot_id == Plan.target.planspot) {
				Plan.target.node.css("left", ((Plan.scale * lm.place.x - 25)) + "px");
				Plan.target.node.css("top", ((Plan.scale * lm.place.y - 25)) + "px");
				$("#plan-points").append(Plan.target.node);
			} else {
				Plan.target.node.remove();
			}

			//ssi("Plan","route",{"folder":Plan.planData.folder, "from":Plan.origin.planspot, "target":Plan.landmarks[Plan.target.current].place.planspot_id},function(resp) {
			ssi("Plan","route",{"folder":Plan.planData.folder, "from":Plan.origin.planspot, "target":Plan.target.planspot}, function(resp) {
				var data = resp.data;
				Plan.route = {};
				Plan.routesA = [];
				Plan.routesB = [];
				Plan.routePlaces = {};

				Plan.target.routeLength = 0;
				for(var n = 0; n < data.path.length -1; n ++) {
					Plan.route[data.path[n]] = data.path[n + 1];
					Plan.routesA.push(data.path[n]);
					Plan.routesB.push(data.path[n + 1]);
					Plan.routePlaces[data.path[n]] = data.places[n];
					Plan.routePlaces[data.path[n + 1]] = data.places[n + 1];
					Plan.target.routeLength ++;
				}
				
				Plan.refreshConnections();
				Plan.refreshHotSpots();
				if (onroute != undefined && onroute != null) {
					onroute();
				}
			});
		}
	},
	
	selectFloor: function(event) {
		if (event != null) {
			var no2;
			no2 = $(event.origin.target).attr("data-no");

			Floors.selectFloors(Plan.landmarks[no2].place.plan_exit);
			
			event.origin.stopPropagation();
		}
	},

	selectTarget: function(event) {
		if (event != null) {
			var no2;
			no2 = $(event.origin.target).attr("data-no");
			
			PlanTarget.mark(Plan.landmarks[no2].place.x, Plan.landmarks[no2].place.y);

			console.log(Plan.landmarks[no2].place);

			var placeName = "";
			placeName = Plan.landmarks[no2].place.place_name;
			if (placeName == "") placeName = "Panorama nr. ";
			//if (placeName == "" && Plan.landmarks[no2].place.psc_name != "" && Plan.landmarks[no2].place.psc_id > 0) placeName = Plan.landmarks[no2].place.psc_name;
			var cat = "";
			if (Plan.landmarks[no2].place.psc_name != "" && Plan.landmarks[no2].place.psc_id > 0) cat = Plan.landmarks[no2].place.psc_name;
			
			//console.log(Plan.landmarks[no2]);

//			Dialog.select("<img src='/html5/assets/end_white.png'>", placeName + Plan.landmarks[no2].place.place_id + "<br><Br>" + "<img src='" + Plan.landmarks[no2].place.thumb + "' width='100%'>", "", ["Przejdź tutaj", "Początek trasy", "Koniec trasy"], function(no) {
			Dialog.route(placeName, Plan.landmarks[no2].place.thumb, cat, Plan.landmarks[no2].place.place_id, TPL.lng("plan.mark_as", "lub oznacz to miejsce jako:"), TPL.lng("plan.goto", "Przejdź tutaj"), TPL.lng("plan.route_begin", "Początek trasy"), TPL.lng("plan.route_end","Koniec trasy"), function(no) {

				if (no == 2) {
					if (Plan.target == null) {
						Plan.target = {};
						Plan.target.node = $("<div class='target'><img src='assets/end_black.png' width='30' height='30'></div>");

					//	Dialog.hint("plan_select_target", "<img src='/html5/assets/end_white.png'>", "Możesz teraz wrócić na widok panoramy<br>i podążyć za punktami oznaczonymi flagą.", 10000);
					}

					Plan.target.current = no2;
					Plan.target.planspot = Plan.landmarks[no2].place.planspot_id;
					Plan.target.title = placeName + " (" + Plan.landmarks[no2].place.place_id + ")";

					$("#route_to span").html("<b>Do:</b> " + placeName + " (" + Plan.landmarks[no2].place.place_id + ")");

					if (Plan.origin.no != undefined) {
						$("#routebar").show();
						Plan.routeBarVisibility(1);
					}
				}

				if (no == 1) {
					if (Plan.origin == null) {
						Plan.origin = {};
					}

					Plan.origin.x = Plan.landmarks[no2].place.x;
					Plan.origin.y = Plan.landmarks[no2].place.y;

					Plan.origin.place = Plan.landmarks[no2].place.place_id;
					Plan.origin.planspot = Plan.landmarks[no2].place.planspot_id;
					Plan.origin.title = placeName + " (" + Plan.landmarks[no2].place.place_id + ")";
					Plan.origin.no = no2;

					Plan.here = Plan.origin;

					Plan.refreshOrigin();

					Plan.startFrom = Plan.landmarks[no2].place.place_id;

					Floors.open();
				}
				
				if (no == 0) {
					mapInfo.toggleMenu();
					player.go(Plan.landmarks[no2].place.place_id, 0);
				}

				Plan.refreshTarget(function() {
					if (Plan.target.routeLength == 0 && Plan.landmarks[Plan.target.current].place.place_id != player.ident) Dialog.flash("<img src='/html5/assets/no_connection.png'>",TPL.lnd("plan.route_not_found","Nie znaleziono trasy."));
				});
			});
			
			event.origin.stopPropagation();
		}
	},

	findNoByPlanspot: function(ps) {
		var n = 0;
		for(var i = 0; i < Plan.landmarks.length; i ++) {
			if (Plan.landmarks[i].place.planspot_id == ps) return i;
		}

		return -1;
	},

	setOriginById: function(id, title) {
		if (Plan.origin != null && Plan.origin != undefined && Plan.origin.node != null) {
			Plan.origin.node.remove();
		}

		Plan.origin = {};
		Plan.origin.no = -1;
		Plan.origin.planspot = id;
		Plan.origin.title = title;		

		Plan.refreshTarget(function() {					
		});
	},

	setTargetById: function(id, title) {
		if (Plan.target == null) {
			Plan.target = {};
			Plan.target.node = $("<div class='target'><img src='assets/end_black.png' width='30' height='30'></div>");
		}

		Plan.target.current = -1;
		Plan.target.planspot = id;
		Plan.target.title = title;

		Plan.refreshTarget(function() {					
		});

		//console.log("target id: " + id);
		/*
		var found = false;
		for(var i in Plan.landmarks) {
			//console.log(Plan.landmarks[i].place.place_id);
			if (Plan.landmarks[i].place.place_id == id) {
				found = true;

				if (Plan.target == null) {
					Plan.target = {};
					Plan.target.node = $("<div class='target'><img src='assets/end_black.png' width='30' height='30'></div>");
					//Plan.target.node.on(Events.pointer.up, function(pe) {Plan.actionTarget();});
				}

				//console.log("Target: " + i);
				var placeName = Plan.landmarks[i].place.place_name;
				if (placeName == "") placeName = "Panorama nr. ";
				if (Plan.landmarks[i].place.psc_name != "" && Plan.landmarks[i].place.psc_id > 0) placeName = Plan.landmarks[i].place.psc_name + " - ";

				Plan.target.current = i;
				Plan.target.planspot = Plan.landmarks[i].place.planspot_id;
				Plan.target.title = placeName + " (" + Plan.landmarks[i].place.place_id + ")";

				Floors.load(Plan.landmarks[i].place.plan_id);
				console.log(Plan.target);

				Plan.refreshTarget(function() {					
					if (Plan.target.routeLength == 0 && Plan.landmarks[Plan.target.current].place.place_id != player.ident)
						Dialog.flash("<img src='/html5/assets/no_connection.png'>","Nie znaleziono trasy.");
				});
				return;
			}
		}

		if (!found) Dialog.flash("<img src='/html5/assets/no_connection.png'>","Nie znaleziono trasy.");
		*/
	},

	refreshHere: function() {
//		Plan.here.node = $("<div class='here'><img src='assets/start_black.png' width='30' height='30'></div>");

		/*
		Plan.here.node = $("<div class='here' data-no='" + Plan.here.no + "'><img src='assets/marker.png' width='30' height='30'></div>");
		Plan.here.node.css("left", ((Plan.scale * Plan.here.x - 25)) + "px");
		Plan.here.node.css("top", ((Plan.scale * Plan.here.y - 25)) + "px");
		$("#plan-points").append(Plan.here.node);

		Plan.here.node.on(Events.pointer.up, function(pe) {Plan.actionHere()});

		Plan.here.node.on(Events.pointer.up, function(pe) {
			Plan.selectTarget(Events.getPointerEvent(pe));
			Plan.swipe.end(Events.getPointerEvent(pe));
			pe.preventDefault();
		});	
		*/		
		if (Plan.origin == null) {
			Plan.origin = {};
		}

		if (Plan.here != null && Plan.here.x != null && Plan.here.y != null) {
			Plan.origin.x = Plan.here.x;
			Plan.origin.y = Plan.here.y;
			Plan.origin.place = Plan.here.place;
			Plan.origin.planspot = Plan.here.planspot;
		}

		Plan.refreshOrigin();
	},
	
	refreshOrigin: function() {
		if (Plan.origin.planspot == undefined) return;

		if (Plan.origin.node != null) {
			Plan.origin.node.remove();
		}

		if (Plan.origin.no == -1) {
			Plan.origin.no = Plan.findNoByPlanspot(Plan.origin.planspot);
			if (Plan.origin.no != -1) {
				Plan.origin.place = Plan.landmarks[Plan.origin.no].place.place_id;
				Plan.origin.x = Plan.landmarks[Plan.origin.no].place.x;
				Plan.origin.y = Plan.landmarks[Plan.origin.no].place.y;
				Plan.here = Plan.origin;
			} else {
				Plan.here = null;
			}
		}

		if (Plan.origin.no > -1 && Plan.origin.no < Plan.landmarks.length && Plan.landmarks[Plan.origin.no].place.planspot_id == Plan.origin.planspot) {

			Plan.origin.node = $("<div class='start'><img src='assets/start_black.png' width='30' height='30'></div>");
			Plan.origin.node.css("left", ((Plan.scale * Plan.origin.x - 25)) + "px");
			Plan.origin.node.css("top", ((Plan.scale * Plan.origin.y - 25)) + "px");
			$("#plan-points").append(Plan.origin.node);

			Plan.origin.node.on(Events.pointer.up, function(pe) {Plan.actionOrigin()});
		}

		$("#route_from span").html("<b>Od: </b>" + Plan.origin.title);

		if (Plan.target != undefined && Plan.target.current != undefined) {
			$("#routebar").show();
			Plan.routeBarVisibility(1);
		}
	},

	refresh: function() {
		$("#plan-points").html("");
		
		$("#cons").css("width", $("#planfile").width() * Plan.scale);
		$("#cons").css("height", $("#planfile").height() * Plan.scale);
		
		for(var i = 0; i < Plan.landmarks.length; i ++) {
			//Plan.planspots[Plan.landmarks[i].place.planspot_id] = Plan.landmarks[i];
			if (Plan.landmarks[i].place.place_id <= 0) {
				if (Plan.landmarks[i].place.plan_exit > 0) {
					var pt = $("<div class='pph' data-no='" + i + "'><div class='plan-point-exit' data-no='" + i + "'><img src='assets/floors.png' width='24' height='24'></div></div>");
				} else {
					continue;
				}
			} else {
				var pt = $("<div class='pph' data-no='" + i + "'><div class='plan-point' data-no='" + i + "'></div></div>");
			}
//			var pt = $("<div class='plan-point' data-no='" + i + "'></div>");
			/*
			pt.css("left", ((Plan.scale * Plan.landmarks[i].place.x - 7)) + "px");
			pt.css("top", ((Plan.scale * Plan.landmarks[i].place.y - 7)) + "px");
			*/

			pt.css("transform","translate3d(" + ((Plan.scale * Plan.landmarks[i].place.x)) + "px, " + ((Plan.scale * Plan.landmarks[i].place.y)) + "px, 0px)")

			$("#plan-points").append(pt);

			Plan.landmarks[i].node = pt;
		}		

		$("#plan-points").show();
		$("#cons").show();
		
		Plan.refreshHere();
		//Plan.refreshTarget();
		
		Plan.refreshTarget(null);		

		Plan.refreshConnections();
	},
	
	connectionInfo: function(a,b) {
		if (Plan.condata[a + "_" + b] != undefined) return Plan.condata[a + "_" + b];
		else if (Plan.condata[b + "_" + a] != undefined) return Plan.condata[b + "_" + a];
		return null;
	},
	
	isConnected: function(a,b) {
		if (Plan.connections[a] == b || Plan.connections[b] == a) return true;
		return false;
	},
	
	setConnection: function(a,b) {
		a = parseFloat(a);
		b = parseFloat(b);		
		Plan.connections[a] = b;
		Plan.connections[b] = a;
	},

	refreshConnections: function() {
		var ids = {};
		var pids = {};

		Plan.connections = {};
		Plan.connectors = [];
		//$("#cons").html("");
		$("#cons").empty();
		
		for(var m in Plan.landmarks) {
			ids[Plan.landmarks[m]['place']['place']] = Plan.landmarks[m];
			pids[Plan.landmarks[m]['place']['planspot_id']] = Plan.landmarks[m];
			if (Plan.landmarks[m].node != undefined) Plan.landmarks[m].node.find(".plan-point").removeClass("plan-routed-point");
		}
		
			for(var m in Plan.landmarks) {
				var mark = Plan.landmarks[m];
				
				for(var s in mark.place.data.spots) {
					var spot = mark.place.data.spots[s];
					var A;
					var B;

					if (ids[spot.ident]) A = ids[spot.ident].place.planspot_id;
					if (ids[mark.place.place]) B = ids[mark.place.place].place.planspot_id;
					
					if (ids[spot.ident] != undefined && !Plan.isConnected(A, B)) {

						Plan.setConnection(A, B);
						
						var info = Plan.connectionInfo(A, B);

						Plan.drawConnection(pids[A], pids[B], info);
																								
						if (Plan.route != undefined && Plan.route != null && (Plan.route[A] == B || Plan.route[B] == A)) {

							pids[A].node.find(".plan-point").addClass("plan-routed-point");
							pids[B].node.find(".plan-point").addClass("plan-routed-point");

							//Plan.drawRoute(A,B, pids);

							/*
							line = document.createElementNS('http://www.w3.org/2000/svg',"polyline"); 
							line.setAttributeNS(null,"points", (pids[A].place.x * Plan.scale) + "," + (pids[A].place.y * Plan.scale) + " " + (pids[B].place.x * Plan.scale) + "," + (pids[B].place.y * Plan.scale));
							line.setAttributeNS(null,"style", "fill:none;stroke:#00ff00;stroke-width:3");
							line.setAttributeNS(null, "stroke-dasharray", "3,3");
							$("#cons").append($(line));
							*/
						}
					}
				}
			}

			for(var k in Plan.condata) {
				var info = Plan.condata[k];
				if (!Plan.isConnected(info.spotA, info.spotB)) {
					Plan.setConnection(info.spotA, info.spotB);
					Plan.drawConnection(pids[info.spotA], pids[info.spotB], info);
					if (Plan.route != undefined && Plan.route != null && (Plan.route[info.spotA] == info.spotB || Plan.route[info.spotB] == info.spotA)) {
						//Plan.drawRoute(info.spotA, info.spotB, pids);
					}
				}
			}
			Plan.drawRoute(pids);
		
	},
	
	drawRoute: function(pids) {
		var rt = "";

		if (Plan.route != undefined && Plan.route != null) {
			for(var ind in Plan.routesA) {
				var p = Plan.routesA[ind];
				var t = Plan.routesB[ind];

				if (rt != "") rt += " ";
				if (pids[p] != undefined) rt += (pids[p].place.x * Plan.scale) + "," + (pids[p].place.y * Plan.scale);
				if (pids[t] != undefined) rt += " " + (pids[t].place.x * Plan.scale) + "," + (pids[t].place.y * Plan.scale);
			};

			//console.log(rt);

			/*
			var line = document.createElementNS('http://www.w3.org/2000/svg',"polyline"); 
			line.setAttributeNS(null,"points", rt);
			line.setAttributeNS(null,"style", "fill:none;stroke:#ffffff;stroke-width:10");
			line.setAttributeNS(null, "stroke-linejoin","round");
			$("#cons").append($(line));		
			*/

			line = document.createElementNS('http://www.w3.org/2000/svg',"polyline"); 
			line.setAttributeNS(null,"points", rt);
			line.setAttributeNS(null,"style", "fill:none;stroke:#00Cf00;stroke-width:7");
			//line.setAttributeNS(null, "stroke-dasharray", "4,4");
			line.setAttributeNS(null, "stroke-linejoin","round");
			$("#cons").append($(line));		
		}

	},
	/*
	drawRoute: function(A, B, pids) {
		if (pids[A].hasOwnProperty("node")) pids[A].node.addClass("plan-routed-point");
		if (pids[B].hasOwnProperty("node")) pids[B].node.addClass("plan-routed-point");

		line = document.createElementNS('http://www.w3.org/2000/svg',"polyline"); 
		line.setAttributeNS(null,"points", (pids[A].place.x * Plan.scale) + "," + (pids[A].place.y * Plan.scale) + " " + (pids[B].place.x * Plan.scale) + "," + (pids[B].place.y * Plan.scale));
		line.setAttributeNS(null,"style", "fill:none;stroke:#ffffff;stroke-width:10");
		line.setAttributeNS(null, "stroke-linejoin","round");
		$("#cons").append($(line));		

		line = document.createElementNS('http://www.w3.org/2000/svg',"polyline"); 
		line.setAttributeNS(null,"points", (pids[A].place.x * Plan.scale) + "," + (pids[A].place.y * Plan.scale) + " " + (pids[B].place.x * Plan.scale) + "," + (pids[B].place.y * Plan.scale));
		line.setAttributeNS(null,"style", "fill:none;stroke:#00Cf00;stroke-width:7");
		line.setAttributeNS(null, "stroke-dasharray", "7,3");
		line.setAttributeNS(null, "stroke-linejoin","round");
		$("#cons").append($(line));		
	},
	*/

	drawConnection: function(a,b, info) {		
		var line = document.createElementNS('http://www.w3.org/2000/svg',"polyline"); 
		line.setAttributeNS(null,"points", (a.place.x * Plan.scale) + "," + (a.place.y * Plan.scale) + " " + (b.place.x * Plan.scale) + "," + (b.place.y * Plan.scale));

		if (info != null) {
			
			if (info.active == "1") {
				switch(info.type) {
					case "P":
						line.setAttributeNS(null,"style", "fill:none;stroke:#F6FF00;stroke-width:1");
					break;
									
					case "U":
						line.setAttributeNS(null,"style", "fill:none;stroke:#F6FF00;stroke-width:1");
					break;
									
					default:
						line.setAttributeNS(null,"style", "fill:none;stroke:#F6FF00;stroke-width:1");
				}
			} else {
				//line.setAttributeNS(null,"style", "fill:none;stroke:#b0b0b0;stroke-width:1");
			}
							
		} else {
			line.setAttributeNS(null,"style", "fill:none;stroke:#F6FF00;stroke-width:1");
		}

		line.setAttributeNS(null, "stroke-dasharray", "2,5");

		$("#cons").append($(line));
	},

	centerTo: function(x,y) {
		Plan.center.x = parseFloat(x) * Plan.scale; Plan.center.y = parseFloat(y) * Plan.scale;		
		Plan.mapNode.resetTransform();
		Plan.mapNode.translate(-(Plan.center.x - Plan._width * 0.5), -(Plan.center.x - Plan._height * 0.5), -1);
		Plan.mapNode.applyTransforms();
	},

	wheel: function(e) {		
		Plan.deltaZoom(e.delta * 0.0003);

		if (Plan.nowheel != undefined && Plan.nowheel != null) clearTimeout(Plan.nowheel);
		Plan.nowheel = setTimeout(function() {Plan.deltaZoom(0); Plan.nowheel = null;}, 100);
	},
	
	process: function() {
		
		Plan.mapNode.resetTransform();
		Plan.mapNode.translate(Plan._width * 0.5, Plan._height * 0.5, 0);
		
		Plan.mapImage.resetTransform();
		Plan.mapImage.scale(Plan.scale, Plan.scale, 1);
		Plan.mapImage.applyTransforms();		
		
		if (Plan.swipe.resizing || Plan.zooming) {
			
			$("#plan-points").hide();
			$("#cons").hide();

			var pscale = Plan.scale;

//			$("#heading").html(Plan.swipe.dist);
			
			if (Plan.swipe.resizing) {
				Plan.scale += Plan.swipe.dist * (0.006 * Plan.scale);
			} else {				
				if (Plan.deltaScale != 0) {
					Plan.scale += Plan.deltaScale;
				} else {
					Plan.scale = Plan.newScale;
				}
			}

			if (Plan.scale > 2) Plan.scale = 2;
			if (Plan.scale < 0.2) Plan.scale = 0.2;
			
			Plan.mapImage.resetTransform();
			Plan.mapImage.scale(Plan.scale, Plan.scale, 1);
			Plan.mapImage.applyTransforms();

			Plan.center.x += ((Plan.imageWidth * Plan.scale - Plan.imageWidth * pscale) * ((Plan.center.x) / (Plan.imageWidth * pscale)));
			Plan.center.y += ((Plan.imageHeight * Plan.scale - Plan.imageHeight * pscale) * ((Plan.center.y) / (Plan.imageHeight * pscale)));

//			$("#heading").html(Math.round(((Plan.center.x) / (Plan.imageWidth * Plan.scale)) * 100));

			if (Plan.repaint != null) clearTimeout(Plan.repaint);
			Plan.repaint = setTimeout(function() {Plan.refresh();}, 100);

		} else {			

			Plan.center.x += Plan.swipe.inertiaX() * 10;
			Plan.center.y -= Plan.swipe.inertiaY() * 15;			
			
			var bounds = {};
			bounds.left = Plan.center.x - (Plan._width) * 0.5;
			bounds.right = Plan.center.x + (Plan._width) * 0.5;
			bounds.top = Plan.center.y - (Plan._height) * 0.5;
			bounds.bottom = Plan.center.y + (Plan._height) * 0.5;

			if (Plan.imageWidth * Plan.scale >= Plan._width) {
				if (bounds.right > Plan.imageWidth * Plan.scale + 150) {
					Plan.center.x = (Plan.imageWidth * Plan.scale) - (player._width) * 0.5 + 150;
				} else

				if (bounds.left < -150) {
					Plan.center.x = player._width * 0.5 - 150;
				}
			
			} else {
				Plan.center.x = (Plan.imageWidth * Plan.scale) * 0.5;
			}
			
			if (Plan.imageHeight * Plan.scale >= Plan._height) {
				if (bounds.bottom > Plan.imageHeight * Plan.scale + 150) {
					Plan.center.y = (Plan.imageHeight * Plan.scale) - (player._height) * 0.5 + 150;
				} else

				if (bounds.top < -150) {
					Plan.center.y = player._height * 0.5 - 150;
				}			
			} else {
				Plan.center.y = (Plan.imageHeight * Plan.scale) * 0.5;
			}
			
			
		}
		
		/*
		if (player.orientation != null && player.orientation.alpha != null && player.orientation.alpha != undefined && Plan.compassMode) {
			//$("#heading").html(Compass.heading());		
			Plan.mapNode.rotateZ(-Compass.heading());
		}		
		*/
		
		Plan.mapNode.translate(-(Plan.center.x), -(Plan.center.y), 0);
		Plan.mapNode.applyTransforms();		
	},
	
	hide: function() {
		$("#mapcontent").html("");		
	},

	goOrigin: function() {
		var pids = {};
		var places = [];
		var psp = [];

//		if (Plan.origin && Plan.origin.place) {
		if (Plan.origin) {
			//player.go(Plan.origin.place, "0");

			//console.log("goOrigin");
			/*
			var m;
			for(var m in Plan.landmarks) {
				pids[parseInt(Plan.landmarks[m]['place']['planspot_id'])] = Plan.landmarks[m];
			}
			*/
			
			for(var p in Plan.routesA) {
				m = Plan.routesA[p];
				psp.push(m);

				/*
				if (pids[parseInt(m)]['place']['place_id'] > 0) {
					places.push(pids[m]['place']['place_id']);
				}
				*/
			}

			m = Plan.routesB[p];
			psp.push(m);
			/*
			if (pids[parseInt(m)]['place']['place_id'] > 0) {
				places.push(pids[m]['place']['place_id']);
			}
			*/
			
//			Autopilot.setRoute(places);
			Autopilot.setRoute(psp);
			Autopilot.start();
		}
	},

	placeReady: function(pe) {

		ssi("Plan","load",{"place":player.ident},function(resp) {
			if (resp.data.plan_id != undefined) {
				Plan.loadLandmarks(resp.data);

				if (Plan.planData.planspot_id != undefined) {
					Plan.here.x = Plan.planData.x; Plan.here.y = Plan.planData.y;
					Plan.here.place = Plan.planData.place;
					Plan.here.planspot = Plan.planData.planspot_id;

					var placeName = player.current.place_name;	
					if (placeName == "") placeName = "Panorama nr. ";

					Plan.here.title = placeName + " " + player.ident;
					Plan.origin = Plan.here;
				} else {
					Plan.here = {};
				}

			}
		});

		Plan.refreshTarget(null);
		Plan.refreshHotSpots();
	},

	refreshHotSpots: function() {		
		var ids = {};
		var pids = {};

		for(var m in Plan.landmarks) {
			ids[Plan.landmarks[m]['place']['place']] = Plan.landmarks[m];
			pids[Plan.landmarks[m]['place']['planspot_id']] = Plan.landmarks[m];
		}		

		for(var i in HotSpotManager.spots) {
			var spot = HotSpotManager.spots[i];

			if (spot.tag != 'default') continue;
			//if (ids[spot.properties.ident] == undefined) continue;
			//var next = ids[spot.properties.ident].place.planspot_id;

			var next = spot.properties.ident;
			
			spot.removeHelper();
			spot.node.find(".mark_direction").remove();

			if (Plan.route != undefined) {
				var itsme = 0;
				var lastFound = null;
				var lastRoute = null;

				for(var n in Plan.routesA) {
					//if (Plan.route.hasOwnProperty(ids[player.ident].place.planspot_id)) itsme = 1;
					if (Plan.routePlaces[Plan.routesA[n]] == player.ident) {
						while (Plan.routePlaces[Plan.routesB[n]] == -1) n ++;

						if (Plan.routePlaces[Plan.routesB[n]] == next) {
							lastFound = n;
							spot.node.find(".mark_direction").remove();
							spot.node.append("<img src='/html5/assets/route_spot.png' class='mark_direction'>");
							spot.addHelper($("<a href='javascript:void(null);' on" + Events.pointer.up + "='player.currentView.turnTo(" + spot.lookAtCoords().x + "," + spot.lookAtCoords().y + ")'><img src='/html5/assets/mark_left.png'></a>"), $("<a href='javascript:void(null);' on" + Events.pointer.up + "='player.currentView.turnTo(" + spot.lookAtCoords().x + "," + spot.lookAtCoords().y + ")'><img src='/html5/assets/mark_right.png'></a>"));
						}
					}
					/*
					if (Plan.routesA[n] == ids[player.ident].place.planspot_id) {
						while (pids[Plan.routesB[n]].place.place == -1) n ++;
						if (Plan.routesB[n] == next) {
							lastFound = n;
							spot.node.find(".mark_direction").remove();
							spot.node.append("<img src='/html5/assets/route_spot.png' class='mark_direction'>");
							spot.addHelper($("<a href='javascript:void(null);' on" + Events.pointer.up + "='player.currentView.turnTo(" + spot.lookAtCoords().x + "," + spot.lookAtCoords().y + ")'><img src='/html5/assets/mark_left.png'></a>"), $("<a href='javascript:void(null);' on" + Events.pointer.up + "='player.currentView.turnTo(" + spot.lookAtCoords().x + "," + spot.lookAtCoords().y + ")'><img src='/html5/assets/mark_right.png'></a>"));
						}
					}
					*/
					lastRoute = n;
				}

				/*
				if (lastFound == lastRoute) {
					spot.node.find(".mark_direction").remove();
					spot.node.append("<img src='/html5/assets/end_white.png' class='mark_direction'>");
					spot.removeHelper();
					spot.addHelper($("<img src='/html5/assets/mark_left.png' class='mark_direction'>"), $("<img src='/html5/assets/mark_right.png' class='mark_direction'>"));
				}
				*/

			} else {
				spot.node.find(".mark_direction").remove();
				spot.removeHelper();
			}
		}

		if (ids[player.ident] != undefined && Plan.routesB != undefined && Plan.routesB[Plan.routesB.length - 1] == ids[player.ident].place.planspot_id) {
			//Dialog.message("<div class='target' style='position:static;'><img src='assets/end_black.png' width='30' height='30'></div>","Dotarłeś do miejsca przeznaczenia", "Zamknij");
			Dialog.message("",TPL.lng("plan.target_reached","<span class='high'>DOTARŁEŚ</span> do miejsca przeznaczenia") + "<br>", TPL.lng("plan.close", "Zamknij"));
			Plan.actionTarget();
		}
		//Dialog.message("<img src='/html5/assets/end_white.png' class='left'> <div class='right'>Dotarłeś do miejsca przeznaczenia</div>", "OK", null);
		
	},

	actionTarget: function() {
		Plan.target.node.remove();
		Plan.target = null;
		Plan.route = null;
		$("#route_to span").html("<b>Do: </b>");
		//$("#routebar span").hide();
		$("#routebar").hide();
		Plan.routeBarVisibility(0);

		Plan.refresh();
	},

	actionHere: function() {
		$(".plan-point").addClass("blinking");
	},

	actionOrigin: function() {
		var loc = "<b>" + Plan.landmarks[Plan.here.no].place.place_name + "(Panorama nr. " + Plan.here.place + ")</b>";
		
		Dialog.flash("<div class='start_icon'><img src='/html5/assets/start_black.png' width='30' height='30'></div>",
			{
				message: "Twoja pozycja:<br> " + loc, 
				help:"<hr size='1'><i>Kliknij na któryś z punktów na mapie aby wyznaczyć nową pozycję.</i>"
			});

		$(".plan-point").removeClass("stretching");
		setTimeout(function() {$(".plan-point").addClass("stretching");}, 50);
	},

	routeBarVisibility: function(v) {
		if (v) {
			$("#route_go_bar").css("opacity", "1");
			$("#route_go_bar").css("bottom", "0");
		} else {
			$("#route_go_bar").css("opacity", "0");
			$("#route_go_bar").css("bottom", "35");			
		}
	},

	checkDoubleTap: function() {
		if (Plan.swipe.doubleTap) {			
			Plan.zooming = true;
			Plan.dtaptween = new Tween(function(c) {Plan.newScale = c;}, function() {Plan.zooming = false;Plan.refresh();});
			Plan.dtaptween.start(Plan.scale, Plan.scale + (1), 1000, "easeInOutQuad");
		}
	},

	deltaZoom: function(step) {
		if (step != 0) {
			Plan.deltaScale = step;
			Plan.zooming = true;
		} else {
			Plan.deltaScale = 0;
			Plan.zooming = false;
			Plan.refresh()
		}
	}
}

PluginManager.add(Plan);